




































import { editFactory } from '@/main/pages';
import { Partner } from '@/modules/kartoteka/partner';
import { openEdit } from '@/main/router/routerPath';
import { Fakturace } from '@/modules/uctenky/fakturace';
import { DokladNaplnFakturaci } from '@/modules/uctenky/fakturace/constants';
import { PageMode } from '@/main/utils/pageMode';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { NAME, TAB_NAMES, ZALOHA_POV, PovDruhEnum } from './constants';
import { store } from './store/edit';
import ZakladniInformace from './tabs/ZakladniInformace.vue';
import DoplnujiciInformace from './tabs/DoplnujiciInformace.vue';
import ZalohyPovCard from './tabs/Zalohy.vue';
import Zarazeni from './tabs/Zarazeni.vue';

export default editFactory(NAME, store).extend({
	components: {
		ZakaznikSelect: Partner.components.Select,
		ZakladniInformace,
		DoplnujiciInformace,
		ZalohyPovCard,
		Zarazeni,
		DmsPdfDialog,
	},
	data() {
		return {
			tabItems: {
				[TAB_NAMES.ZAKLADNI_INFORMACE]: { id: 'zInfo', labelKey: 'Z_Info' },
				[TAB_NAMES.DOPLNUJICI_INFORMACE]: { id: 'dInfo', labelKey: 'D_Info' },
				[TAB_NAMES.ZALOHY_POV]: { id: 'pagePovZaloha', labelKey: 'pagePOVZaloha' },
				[TAB_NAMES.ZARAZENI]: { id: 'zarazeni', labelKey: 'Zarazeni' },
			},
			tabNames: TAB_NAMES,
			dependencies: { ZALOHA_POV },
			povDruhEnum: PovDruhEnum,
		};
	},
	computed: {
		povDruh(): PovDruhEnum {
			if (!this.UvolneniDat && !this.UzavreniDat) return PovDruhEnum.POV_OTEVRENE;
			if (!!this.UvolneniDat && !this.UzavreniDat) return PovDruhEnum.POV_UVOLNENE;
			if (!!this.UvolneniDat && !!this.UzavreniDat) return PovDruhEnum.POV_UZAVRENE;
			return PovDruhEnum.POV_UNDEFINED;
		},
	},
	watch: {
		PovNr(val) {
			if (val !== null && val !== 0) {
				this.titleDetail = val;
			}
		},
	},
	methods: {
		async fakturaceClicked(dokladNaplnFakturaci: DokladNaplnFakturaci = DokladNaplnFakturaci.DRUHY_DD) {
			this.startLoading();
			try {			
					await openEdit(Fakturace.name, PageMode.CREATE, {
						filter: {
							povId: this.PovId, dokladNaplnFakturaci,
						},
					});				
			} finally {
				this.endLoading();
			}
		},
		async createZaloha() {
			if (this.isCreateMode) {
				await this.changeToEdit();
			}
			if (this.isModified) {
				await this.save(false);
			}
			const filter = {
				PovId: this.PovId!,
				PovNr: this.PovNr,
				ZakaznikIdText: this.ZakaznikIdText,
				VozidloText: this.VozidloText,
			};
			openEdit(ZALOHA_POV, PageMode.CREATE, { props: true, filter });
		},
	},
});
